/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {batchTopicSync} from '../api'

 export const useQueryBatchTopicSync = createReactQueryHook('batchTopicSync', batchTopicSync)
